export const StepContent = {
  NAME: {
    ERROR_MESSAGE: 'Name must be at least 3 characters and can only contain letters, hyphens and apostrophes',
    FIRST_AND_LAST_NAME_ERROR_MESSAGE: 'Please provide both a first and last name',
    PLACEHOLDER: 'e.g. John Doe',
    LABEL: 'Full Name',
  },
};
